import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
    Button, CircularProgress,
    DialogActions,
    DialogContent, FormControlLabel, Grid, Switch, TextField, Box
} from "@material-ui/core";
import { withRouter } from "react-router";
import { closeModal, createTopic, fetchTopics, showModal, subscribeTopic, updateTopic } from "../../actions";
import DatePickerComp from "../dateTimePickers/DatePickerComp";
import TimePicker from "../dateTimePickers/TimePicker";
import AutocompleteTagField from "../autocompleteField/AutocompleteTagField";
import Typography from "@material-ui/core/Typography";
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import IconButton from "@material-ui/core/IconButton";
import { DateTime } from "luxon";
import history from "./../../history";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const styles = theme => ({
    textField: {
        '& .MuiOutlinedInput-root': {
            padding: 0
        },
        '& textarea': {
            padding: '1rem 1.5rem'
        },
        '& textarea:focus + fieldset': {
            borderColor: `#ffffff !important`,
            borderWidth: 2,
        },
        '& textarea:focus:hover + fieldset': {
            borderColor: `#ffffff !important`,
            borderWidth: 2,
        },
        '& input': {
            padding: '1rem 1.5rem'
        },
        '& input:focus + fieldset': {
            borderColor: `#ffffff !important`,
            borderWidth: 2,
        },
        '& input:focus:hover + fieldset': {
            borderColor: `#ffffff !important`,
            borderWidth: 2,
        },
    },
    buttonPrimary: {
        margin: '0.313rem',
        padding: '0.313rem 1.563rem',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.light.default,
        '&:hover': {
            backgroundColor: '#e85343',
        }

    },
    iconDelete: {
        color: theme.palette.secondary.main
    },
    modalHeaderWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1rem'
    }
});

class ModalContent extends Component {


    state = {
        isTopicPublic: true,
        title: '',
        description: '',
        start_at: null,
        end_at: null,
        user_id: this.props.userData.data.id,
        timezone: this.props.userData.currentTimeZone,
        date: DateTime.local().setZone(this.props.userData.currentTimeZone),
        locationPath: this.props.location.pathname,
        tags: null,
        buttonType: null,
        topicId: null,
        conferences: this.props.conferences,
        createdTopic: {},
        showLoadBtn: false,
        titleCharsLeft: 200,
        titleMaxChars: 200,
    }

    componentDidMount() {
        //get info from updated topic
        let topic = this.props.modal.data.content
        if (typeof this.props.modal.data.content === "object") {
            this.setState({
                buttonType: 'update',
                title: topic.title,
                titleCharsLeft: this.state.titleMaxChars - topic.title.length,
                description: topic.description,
                start_at: DateTime.fromISO(topic.start_at, { zone: this.state.timezone }),
                end_at: DateTime.fromISO(topic.end_at, { zone: this.state.timezone }),
                date: DateTime.fromISO(topic.start_at, { zone: this.state.timezone }).toISODate(),
                topicId: topic.id,
                defaultTags: topic.tags,
                updateEventMethod: 'PUT'
            })
        } else {
            this.setState({
                buttonType: 'create',
                title: topic,
                description: '',
                start_at: DateTime.local().setZone(this.state.timezone),
                end_at: DateTime.local().setZone(this.state.timezone),
                date: DateTime.local().setZone(this.state.timezone).toISODate()
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.createdTopic &&
            Object.keys(this.props.createdTopic).length !== 0 &&
            this.props.createdTopic !== this.state.createdTopic) {

            this.setState({
                createdTopic: this.props.createdTopic
            })
        }
    }

    closeModal = () => {
        this.setState({ modalIsOpen: false })
        this.props.closeModal('modal-set-topic')
        if (localStorage.getItem("topic_title") !== null) {
            localStorage.removeItem('topic_title');
        }
    };

    addTopicValue = (e) => {
        this.setState({ title: e.target.value })
        const charCount = e.target.value.length;
        const maxChar = this.state.titleMaxChars;
        const charLength = maxChar - charCount;
        this.setState({ titleCharsLeft: charLength });
    }

    addTopicDescription = (e) => {
        this.setState({ description: e.target.value })
    }

    addTopicDate = (data) => {
        switch (data.type) {
            case 'startDate':
                return this.setState({ start_at: data.date.setZone(this.state.timezone) })
            case 'endDate':
                return this.setState({ end_at: data.date.setZone(this.state.timezone) })
            case 'date':
                return this.setState({ date: data.date })
        }
    }

    isTopicPublic = () => {
        this.setState({ isTopicPublic: !this.state.isTopicPublic })
    }

    formIsValid = () => {

        // console.log(DateTime.fromISO(this.state.end_at).toFormat('f') + ' >= ' + DateTime.local().toFormat('f'));
        // console.log(this.state.end_at >= DateTime.local());

        // && DateTime.fromISO(this.state.date) === DateTime.local()

        if (this.state.title && this.state.start_at < this.state.end_at && this.state.end_at > DateTime.local() && this.state.end_at >= DateTime.local()) {
            // if tha date is today
            return true
        } else return this.state.title && DateTime.fromISO(this.state.date) > DateTime.local() && this.state.start_at < this.state.end_at;

    }

    getTags = (tags) => {
        this.setState({ tags: tags })
    }

    handleAutocompleteTagField = () => {
        if (this.state.buttonType === 'update' && this.state.defaultTags) {
            return (
                <AutocompleteTagField dispatchedTags={this.getTags}
                    defaultTags={this.state.defaultTags} />
            )
        } else if (this.state.buttonType === 'create') {
            return (
                <AutocompleteTagField dispatchedTags={this.getTags} />
            )
        }
    }

    buildTopic = () => {
        let title = this.state.title;
        let description = this.state.description;
        let start_at;
        let end_at;
        if (typeof this.state.date === "object") {
            start_at = this.state.date.toISODate() + ' ' + this.state.start_at.toFormat('HH:mm') + ', ' + this.state.timezone;
            end_at = this.state.date.toISODate() + ' ' + this.state.end_at.toFormat('HH:mm') + ', ' + this.state.timezone;
        } else {
            start_at = this.state.date + ' ' + this.state.start_at.toFormat('HH:mm') + ', ' + this.state.timezone;
            end_at = this.state.date + ' ' + this.state.end_at.toFormat('HH:mm') + ', ' + this.state.timezone;
        }


        let user_id = this.state.user_id;
        let tags = this.state.tags ? this.state.tags : this.state.defaultTags;
        let formData = new FormData();

        formData.append('title', title)
        formData.append('description', description)
        formData.append('conference_uuid', this.state.conferences.data.uuid)
        formData.append('user_id', user_id)
        formData.append('start_at', start_at)
        formData.append('end_at', end_at)

        if (this.state.buttonType === 'update') {
            formData.append('_method', this.state.updateEventMethod)
        }

        if (tags && tags.length > 0) {
            for (let i = 0; i < tags.length; i++) {
                if (typeof tags[i] === "string") {
                    formData.append('tags[]', tags[i]);
                } else {
                    formData.append('tags[]', tags[i].id);
                }
            }
        }

        return formData
    }

    createTopic = () => {
        this.props.createTopic(this.buildTopic())
            .then(() => {
                this.setState({
                    showLoadButton: true
                })
                if (this.state.createdTopic) {
                    this.props.subscribeTopic({ topic_id: this.state.createdTopic.id })
                        .then(() => {
                            this.closeModal()
                            window.location.reload()
                        })
                }
            })
    }

    updateTopic = () => {
        this.props.updateTopic(this.buildTopic(), this.state.topicId)
            .then(() => {
                window.location.reload()
            })

        this.closeModal()
    }

    deleteTopic = (type, data) => {
        this.closeModal()
        this.props.showModal(type, data)
    }

    render() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <DialogContent
                    className='modal__set-topic'>
                    <div className={classes.modalHeaderWrapper}>
                        {
                            this.state.buttonType === 'create'
                                ?
                                <Typography variant='h5' style={{ margin: 0 }}>
                                    Create a NEW conversation room
                                </Typography>
                                :
                                <Typography variant='h5'>
                                    Update conversation room
                                </Typography>
                        }

                        <IconButton
                            onClick={this.closeModal}
                            aria-label="delete"
                            className={classes.margin}>
                            <CancelOutlinedIcon fontSize="large" />
                        </IconButton>

                    </div>
                    <Grid
                        container
                        spacing={2}
                        className='modal__set-topic__content__wrap'
                    >
                        <Grid item xs={6}>
                            <Box mt={2} mb={1}>
                                Conversation room
                            </Box>
                            <TextField
                                id="outlined-multiline-static"
                                value={this.state.title}
                                onChange={this.addTopicValue}
                                fullWidth
                                className={classes.textField}
                                variant="outlined"
                                inputProps={{ maxLength: this.state.titleMaxChars }}
                                helperText={this.state.titleCharsLeft + ' characters remaining'}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            {
                                this.state.start_at && this.state.end_at
                                    ?
                                    <Grid
                                        container
                                        spacing={2}
                                    >
                                        <Grid item md={4}>
                                            <DatePickerComp
                                                datePickerData={this.addTopicDate}
                                                type='date'
                                                date={this.state.date}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <TimePicker
                                                timePickerData={this.addTopicDate}
                                                type='startDate'
                                                time={this.state.start_at}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <TimePicker
                                                timePickerData={this.addTopicDate}
                                                type='endDate'
                                                time={this.state.end_at}
                                            />
                                        </Grid>
                                    </Grid>
                                    :
                                    null
                            }
                        </Grid>
                    </Grid>

                    <Box mt={2} mb={1}>
                        Description (optional)
                    </Box>
                    <Grid
                        container
                        spacing={2}
                        className='modal__set-topic__content__wrap mt-2 mb-24'
                    >
                        <Grid item xs={12}>
                            <TextField
                                id="outlined-multiline-static"
                                multiline
                                rows={3}
                                className={`${classes.textField} w-100`}
                                value={this.state.description}
                                onChange={this.addTopicDescription}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>

                    <Box mt={3} mb={0}>
                        Tags (press return/enter after each tag)
                    </Box>
                    <Grid
                        container
                        spacing={2}
                        className='modal__set-topic__content__wrap mt-2 mb-24'
                    >
                        <Grid item xs={6}>
                            {this.handleAutocompleteTagField()}

                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <div className='modal__set-topic__control-buttons'>
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.isTopicPublic}
                                                    // onChange={() => {
                                                    //     this.isTopicPublic()
                                                    // }}
                                                    color="secondary"
                                                    name="make topic public"
                                                    inputProps={{ 'aria-label': 'public topic checkbox' }} />}
                                            label="Public"
                                        />
                                    </div>
                                    <div>

                                        {
                                            this.state.buttonType === 'create'
                                                ?
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={!this.formIsValid() || this.state.showLoadButton}
                                                    className={classes.buttonPrimary}
                                                    onClick={() => {
                                                        this.createTopic()
                                                    }}
                                                >
                                                    <span
                                                        style={{ display: !this.state.showLoadButton ? 'block' : 'none' }}>create</span>
                                                    <span
                                                        style={{ display: this.state.showLoadButton ? 'block' : 'none' }}>
                                                        <CircularProgress color="primary" />
                                                    </span>
                                                </Button>
                                                :
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={!this.formIsValid()}
                                                    className={classes.buttonPrimary}
                                                    onClick={() => {
                                                        this.updateTopic()
                                                    }}
                                                >
                                                    update
                                                </Button>
                                        }
                                        <IconButton
                                            onClick={() => {
                                                this.deleteTopic('modal-delete-topic', {
                                                    topicTitle: this.state.title,
                                                    topicId: this.state.topicId,
                                                    conferenceUUID: this.state.conferences.data.uuid,
                                                    deleteObject: 'conversation'
                                                })
                                            }}
                                            disabled={this.state.buttonType === 'create'}
                                            aria-label="delete"
                                            className={classes.iconDelete}>
                                            <DeleteForeverIcon fontSize="large" />
                                        </IconButton>
                                    </div>
                                </div>
                            </DialogActions>
                        </Grid>
                    </Grid>
                </DialogContent>
            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        modal: state.modal,
        userData: state.user,
        topics: state.topics,
        createdTopic: state.topics.createdTopic,
        conferences: state.conferences,
    }
}

const mapDispatchToProps = dispatch => ({
    closeModal: data => dispatch(closeModal(data)),
    showModal: (type, data) => dispatch(showModal(type, data)),
    createTopic: data => dispatch(createTopic(data)),
    fetchTopics: data => dispatch(fetchTopics(data)),
    subscribeTopic: topicId => dispatch(subscribeTopic(topicId)),
    updateTopic: (data, topicId) => dispatch(updateTopic(data, topicId))
})

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(ModalContent)));
